import { createSlice } from "@reduxjs/toolkit";
import { parseTeamSectionResponse } from "../Common/teamApi";

export const teamDataSlice = createSlice({
  name: "teamData",
  initialState: {
    teamSection: [],
    teamSum: null,
  },
  reducers: {
    setTeamData: (state, action) => {
      const { teamSection, teamSum } = parseTeamSectionResponse(action.payload);
      state.teamSection = teamSection;
      state.teamSum = teamSum;
    },
  },
});

export const { setTeamData } = teamDataSlice.actions;
export default teamDataSlice.reducer;
